var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.772,31.102h-2.273v-2.379c0-1.104-0.896-2-2-2s-2,0.896-2,2v2.379H37.501v-2.379c0-1.104-0.896-2-2-2s-2,0.896-2,2 v2.379h-2.274c-4.086,0-7.411,3.325-7.411,7.412v23.353c0,4.087,3.325,7.411,7.411,7.411h33.545c4.087,0,7.411-3.324,7.411-7.411 V38.513C72.184,34.426,68.859,31.102,64.772,31.102z M68.184,61.866c0,1.881-1.53,3.411-3.411,3.411H31.228 c-1.881,0-3.411-1.53-3.411-3.411V44.361h40.367V61.866z M68.184,40.361H27.816v-1.848c0-1.881,1.53-3.412,3.411-3.412h2.274v1.955 c0,1.104,0.896,2,2,2s2-0.896,2-2v-1.955h20.998v1.955c0,1.104,0.896,2,2,2s2-0.896,2-2v-1.955h2.273 c1.881,0,3.411,1.53,3.411,3.412V40.361z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8712ac66d8fba7937e3a1950ec7a7d86.svg";
export { ForwardRef as ReactComponent };